// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  --mat-app-background-color: #fff8f5;
  --mat-app-text-color: #201a17;
  --mat-app-elevation-shadow-level-0: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-1: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-2: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-3: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-4: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-5: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-6: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-7: 0px 4px 5px -2px rgba(0, 0, 0, 0.2), 0px 7px 10px 1px rgba(0, 0, 0, 0.14), 0px 2px 16px 1px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-8: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-9: 0px 5px 6px -3px rgba(0, 0, 0, 0.2), 0px 9px 12px 1px rgba(0, 0, 0, 0.14), 0px 3px 16px 2px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-10: 0px 6px 6px -3px rgba(0, 0, 0, 0.2), 0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-11: 0px 6px 7px -4px rgba(0, 0, 0, 0.2), 0px 11px 15px 1px rgba(0, 0, 0, 0.14), 0px 4px 20px 3px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-12: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-13: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 13px 19px 2px rgba(0, 0, 0, 0.14), 0px 5px 24px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-14: 0px 7px 9px -4px rgba(0, 0, 0, 0.2), 0px 14px 21px 2px rgba(0, 0, 0, 0.14), 0px 5px 26px 4px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-15: 0px 8px 9px -5px rgba(0, 0, 0, 0.2), 0px 15px 22px 2px rgba(0, 0, 0, 0.14), 0px 6px 28px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-16: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-17: 0px 8px 11px -5px rgba(0, 0, 0, 0.2), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-18: 0px 9px 11px -5px rgba(0, 0, 0, 0.2), 0px 18px 28px 2px rgba(0, 0, 0, 0.14), 0px 7px 34px 6px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-19: 0px 9px 12px -6px rgba(0, 0, 0, 0.2), 0px 19px 29px 2px rgba(0, 0, 0, 0.14), 0px 7px 36px 6px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-20: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-21: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 21px 33px 3px rgba(0, 0, 0, 0.14), 0px 8px 40px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-22: 0px 10px 14px -6px rgba(0, 0, 0, 0.2), 0px 22px 35px 3px rgba(0, 0, 0, 0.14), 0px 8px 42px 7px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-23: 0px 11px 14px -7px rgba(0, 0, 0, 0.2), 0px 23px 36px 3px rgba(0, 0, 0, 0.14), 0px 9px 44px 8px rgba(0, 0, 0, 0.12);
  --mat-app-elevation-shadow-level-24: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  --mat-ripple-color: color-mix(in srgb, #201a17 10%, transparent);
  --mat-option-focus-state-layer-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-option-hover-state-layer-color: color-mix(in srgb, #201a17 8%, transparent);
  --mat-option-label-text-color: #201a17;
  --mat-option-selected-state-label-text-color: #5b4130;
  --mat-option-selected-state-layer-color: #ffdcc7;
  --mat-optgroup-label-text-color: #52443c;
  --mat-pseudo-checkbox-full-disabled-selected-checkmark-color: #fff8f5;
  --mat-pseudo-checkbox-full-disabled-selected-icon-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-pseudo-checkbox-full-disabled-unselected-icon-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-pseudo-checkbox-full-selected-checkmark-color: #ffffff;
  --mat-pseudo-checkbox-full-selected-icon-color: #964900;
  --mat-pseudo-checkbox-full-unselected-icon-color: #52443c;
  --mat-pseudo-checkbox-minimal-disabled-selected-checkmark-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-pseudo-checkbox-minimal-selected-checkmark-color: #964900;
  --mat-option-label-text-size: 1rem;
  --mat-option-label-text-weight: 400;
  --mat-option-label-text-font: Roboto, sans-serif;
  --mat-option-label-text-line-height: 1.25rem;
  --mat-option-label-text-tracking: 0.006rem;
  --mat-optgroup-label-text-font: Roboto, sans-serif;
  --mat-optgroup-label-text-line-height: 1.25rem;
  --mat-optgroup-label-text-size: 0.875rem;
  --mat-optgroup-label-text-tracking: 0.006rem;
  --mat-optgroup-label-text-weight: 500;
  --mat-card-elevated-container-shape: 12px;
  --mat-card-filled-container-shape: 12px;
  --mat-card-outlined-container-shape: 12px;
  --mat-card-outlined-outline-width: 1px;
  --mat-card-elevated-container-color: #fef1ec;
  --mat-card-elevated-container-elevation: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-card-filled-container-color: #ece0da;
  --mat-card-filled-container-elevation: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-card-outlined-container-color: #fff8f5;
  --mat-card-outlined-container-elevation: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-card-outlined-outline-color: #d7c3b8;
  --mat-card-subtitle-text-color: #201a17;
  --mat-card-subtitle-text-font: Roboto, sans-serif;
  --mat-card-subtitle-text-line-height: 1.5rem;
  --mat-card-subtitle-text-size: 1rem;
  --mat-card-subtitle-text-tracking: 0.009rem;
  --mat-card-subtitle-text-weight: 500;
  --mat-card-title-text-font: Roboto, sans-serif;
  --mat-card-title-text-line-height: 1.75rem;
  --mat-card-title-text-size: 1.375rem;
  --mat-card-title-text-tracking: 0;
  --mat-card-title-text-weight: 400;
  --mat-progress-bar-active-indicator-height: 4px;
  --mat-progress-bar-track-height: 4px;
  --mat-progress-bar-track-shape: 0;
  --mat-progress-bar-active-indicator-color: #964900;
  --mat-progress-bar-track-color: #f4ded3;
  --mat-tooltip-container-color: #362f2b;
  --mat-tooltip-container-shape: 4px;
  --mat-tooltip-supporting-text-color: #fbeee8;
  --mat-tooltip-supporting-text-font: Roboto, sans-serif;
  --mat-tooltip-supporting-text-line-height: 1rem;
  --mat-tooltip-supporting-text-size: 0.75rem;
  --mat-tooltip-supporting-text-tracking: 0.025rem;
  --mat-tooltip-supporting-text-weight: 400;
  --mat-form-field-filled-active-indicator-height: 1px;
  --mat-form-field-filled-focus-active-indicator-height: 2px;
  --mat-form-field-filled-container-shape: 4px;
  --mat-form-field-outlined-outline-width: 1px;
  --mat-form-field-outlined-focus-outline-width: 2px;
  --mat-form-field-outlined-container-shape: 4px;
  --mat-form-field-disabled-input-text-placeholder-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-form-field-disabled-leading-icon-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-form-field-disabled-select-arrow-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-form-field-disabled-trailing-icon-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-form-field-enabled-select-arrow-color: #52443c;
  --mat-form-field-error-focus-trailing-icon-color: #ba1a1a;
  --mat-form-field-error-hover-trailing-icon-color: #93000a;
  --mat-form-field-error-text-color: #ba1a1a;
  --mat-form-field-error-trailing-icon-color: #ba1a1a;
  --mat-form-field-filled-active-indicator-color: #52443c;
  --mat-form-field-filled-caret-color: #964900;
  --mat-form-field-filled-container-color: #f4ded3;
  --mat-form-field-filled-disabled-active-indicator-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-form-field-filled-disabled-container-color: color-mix(in srgb, #201a17 4%, transparent);
  --mat-form-field-filled-disabled-input-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-form-field-filled-disabled-label-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-form-field-filled-error-active-indicator-color: #ba1a1a;
  --mat-form-field-filled-error-caret-color: #ba1a1a;
  --mat-form-field-filled-error-focus-active-indicator-color: #ba1a1a;
  --mat-form-field-filled-error-focus-label-text-color: #ba1a1a;
  --mat-form-field-filled-error-hover-active-indicator-color: #93000a;
  --mat-form-field-filled-error-hover-label-text-color: #93000a;
  --mat-form-field-filled-error-label-text-color: #ba1a1a;
  --mat-form-field-filled-focus-active-indicator-color: #964900;
  --mat-form-field-filled-focus-label-text-color: #964900;
  --mat-form-field-filled-hover-active-indicator-color: #201a17;
  --mat-form-field-filled-hover-label-text-color: #52443c;
  --mat-form-field-filled-input-text-color: #201a17;
  --mat-form-field-filled-input-text-placeholder-color: #52443c;
  --mat-form-field-filled-label-text-color: #52443c;
  --mat-form-field-focus-select-arrow-color: #964900;
  --mat-form-field-focus-state-layer-opacity: 0;
  --mat-form-field-hover-state-layer-opacity: 0.08;
  --mat-form-field-leading-icon-color: #52443c;
  --mat-form-field-outlined-caret-color: #964900;
  --mat-form-field-outlined-disabled-input-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-form-field-outlined-disabled-label-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-form-field-outlined-disabled-outline-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-form-field-outlined-error-caret-color: #ba1a1a;
  --mat-form-field-outlined-error-focus-label-text-color: #ba1a1a;
  --mat-form-field-outlined-error-focus-outline-color: #ba1a1a;
  --mat-form-field-outlined-error-hover-label-text-color: #93000a;
  --mat-form-field-outlined-error-hover-outline-color: #93000a;
  --mat-form-field-outlined-error-label-text-color: #ba1a1a;
  --mat-form-field-outlined-error-outline-color: #ba1a1a;
  --mat-form-field-outlined-focus-label-text-color: #964900;
  --mat-form-field-outlined-focus-outline-color: #964900;
  --mat-form-field-outlined-hover-label-text-color: #201a17;
  --mat-form-field-outlined-hover-outline-color: #201a17;
  --mat-form-field-outlined-input-text-color: #201a17;
  --mat-form-field-outlined-input-text-placeholder-color: #52443c;
  --mat-form-field-outlined-label-text-color: #52443c;
  --mat-form-field-outlined-outline-color: #84746a;
  --mat-form-field-select-disabled-option-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-form-field-select-option-text-color: #201a17;
  --mat-form-field-state-layer-color: #201a17;
  --mat-form-field-trailing-icon-color: #52443c;
  --mat-form-field-container-height: 56px;
  --mat-form-field-filled-label-display: block;
  --mat-form-field-container-vertical-padding: 16px;
  --mat-form-field-filled-with-label-container-padding-top: 24px;
  --mat-form-field-filled-with-label-container-padding-bottom: 8px;
  --mat-form-field-container-text-font: Roboto, sans-serif;
  --mat-form-field-container-text-line-height: 1.5rem;
  --mat-form-field-container-text-size: 1rem;
  --mat-form-field-container-text-tracking: 0.031rem;
  --mat-form-field-container-text-weight: 400;
  --mat-form-field-subscript-text-font: Roboto, sans-serif;
  --mat-form-field-subscript-text-line-height: 1rem;
  --mat-form-field-subscript-text-size: 0.75rem;
  --mat-form-field-subscript-text-tracking: 0.025rem;
  --mat-form-field-subscript-text-weight: 400;
  --mat-form-field-outlined-label-text-font: Roboto, sans-serif;
  --mat-form-field-outlined-label-text-size: 1rem;
  --mat-form-field-outlined-label-text-tracking: 0.031rem;
  --mat-form-field-outlined-label-text-weight: 400;
  --mat-form-field-filled-label-text-font: Roboto, sans-serif;
  --mat-form-field-filled-label-text-size: 1rem;
  --mat-form-field-filled-label-text-tracking: 0.031rem;
  --mat-form-field-filled-label-text-weight: 400;
  --mat-select-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-select-panel-background-color: #f8ebe6;
  --mat-select-enabled-trigger-text-color: #201a17;
  --mat-select-disabled-trigger-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-select-placeholder-text-color: #52443c;
  --mat-select-enabled-arrow-color: #52443c;
  --mat-select-disabled-arrow-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-select-focused-arrow-color: #964900;
  --mat-select-invalid-arrow-color: #ba1a1a;
  --mat-select-arrow-transform: translateY(-8px);
  --mat-select-trigger-text-font: Roboto, sans-serif;
  --mat-select-trigger-text-line-height: 1.5rem;
  --mat-select-trigger-text-size: 1rem;
  --mat-select-trigger-text-tracking: 0.031rem;
  --mat-select-trigger-text-weight: 400;
  --mat-autocomplete-container-shape: 4px;
  --mat-autocomplete-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-autocomplete-background-color: #f8ebe6;
  --mat-dialog-actions-alignment: flex-end;
  --mat-dialog-actions-padding: 16px 24px;
  --mat-dialog-container-elevation-shadow: none;
  --mat-dialog-container-max-width: 560px;
  --mat-dialog-container-min-width: 280px;
  --mat-dialog-container-shape: 28px;
  --mat-dialog-container-small-max-width: calc(100vw - 32px);
  --mat-dialog-content-padding: 20px 24px;
  --mat-dialog-headline-padding: 6px 24px 13px;
  --mat-dialog-with-actions-content-padding: 20px 24px 0;
  --mat-dialog-container-color: #fff8f5;
  --mat-dialog-subhead-color: #201a17;
  --mat-dialog-supporting-text-color: #52443c;
  --mat-dialog-subhead-font: Roboto, sans-serif;
  --mat-dialog-subhead-line-height: 2rem;
  --mat-dialog-subhead-size: 1.5rem;
  --mat-dialog-subhead-tracking: 0;
  --mat-dialog-subhead-weight: 400;
  --mat-dialog-supporting-text-font: Roboto, sans-serif;
  --mat-dialog-supporting-text-line-height: 1.25rem;
  --mat-dialog-supporting-text-size: 0.875rem;
  --mat-dialog-supporting-text-tracking: 0.016rem;
  --mat-dialog-supporting-text-weight: 400;
  --mat-chip-container-shape-radius: 8px;
  --mat-chip-disabled-container-opacity: 1;
  --mat-chip-elevated-container-color: transparent;
  --mat-chip-flat-selected-outline-width: 0;
  --mat-chip-outline-width: 1px;
  --mat-chip-trailing-action-focus-opacity: 1;
  --mat-chip-trailing-action-opacity: 1;
  --mat-chip-with-avatar-avatar-shape-radius: 24px;
  --mat-chip-with-avatar-avatar-size: 24px;
  --mat-chip-with-avatar-disabled-avatar-opacity: 0.38;
  --mat-chip-with-icon-disabled-icon-opacity: 0.38;
  --mat-chip-with-icon-icon-size: 18px;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-opacity: 0.38;
  --mat-chip-disabled-label-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-chip-disabled-outline-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-chip-elevated-selected-container-color: #ffdcc7;
  --mat-chip-flat-disabled-selected-container-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-chip-focus-outline-color: #52443c;
  --mat-chip-focus-state-layer-color: #52443c;
  --mat-chip-focus-state-layer-opacity: 0.12;
  --mat-chip-hover-state-layer-color: #52443c;
  --mat-chip-hover-state-layer-opacity: 0.08;
  --mat-chip-label-text-color: #52443c;
  --mat-chip-outline-color: #84746a;
  --mat-chip-selected-disabled-trailing-icon-color: #201a17;
  --mat-chip-selected-focus-state-layer-color: #5b4130;
  --mat-chip-selected-focus-state-layer-opacity: 0.12;
  --mat-chip-selected-hover-state-layer-color: #5b4130;
  --mat-chip-selected-hover-state-layer-opacity: 0.08;
  --mat-chip-selected-label-text-color: #5b4130;
  --mat-chip-selected-trailing-action-state-layer-color: #5b4130;
  --mat-chip-selected-trailing-icon-color: #5b4130;
  --mat-chip-trailing-action-focus-state-layer-opacity: 0.12;
  --mat-chip-trailing-action-hover-state-layer-opacity: 0.08;
  --mat-chip-trailing-action-state-layer-color: #52443c;
  --mat-chip-with-icon-disabled-icon-color: #201a17;
  --mat-chip-with-icon-icon-color: #52443c;
  --mat-chip-with-icon-selected-icon-color: #5b4130;
  --mat-chip-with-trailing-icon-disabled-trailing-icon-color: #201a17;
  --mat-chip-with-trailing-icon-trailing-icon-color: #52443c;
  --mat-chip-container-height: 32px;
  --mat-chip-label-text-font: Roboto, sans-serif;
  --mat-chip-label-text-line-height: 1.25rem;
  --mat-chip-label-text-size: 0.875rem;
  --mat-chip-label-text-tracking: 0.006rem;
  --mat-chip-label-text-weight: 500;
  --mat-slide-toggle-disabled-selected-handle-opacity: 1;
  --mat-slide-toggle-disabled-selected-icon-opacity: 0.38;
  --mat-slide-toggle-disabled-track-opacity: 0.12;
  --mat-slide-toggle-disabled-unselected-handle-opacity: 0.38;
  --mat-slide-toggle-disabled-unselected-icon-opacity: 0.38;
  --mat-slide-toggle-disabled-unselected-track-outline-width: 2px;
  --mat-slide-toggle-handle-shape: 9999px;
  --mat-slide-toggle-hidden-track-opacity: 0;
  --mat-slide-toggle-hidden-track-transition: opacity 75ms;
  --mat-slide-toggle-pressed-handle-size: 28px;
  --mat-slide-toggle-selected-handle-horizontal-margin: 0 24px;
  --mat-slide-toggle-selected-handle-size: 24px;
  --mat-slide-toggle-selected-icon-size: 16px;
  --mat-slide-toggle-selected-pressed-handle-horizontal-margin: 0 22px;
  --mat-slide-toggle-selected-track-outline-color: transparent;
  --mat-slide-toggle-selected-track-outline-width: 2px;
  --mat-slide-toggle-selected-with-icon-handle-horizontal-margin: 0 24px;
  --mat-slide-toggle-state-layer-size: 40px;
  --mat-slide-toggle-track-height: 32px;
  --mat-slide-toggle-track-outline-width: 2px;
  --mat-slide-toggle-track-shape: 9999px;
  --mat-slide-toggle-track-width: 52px;
  --mat-slide-toggle-unselected-handle-horizontal-margin: 0 8px;
  --mat-slide-toggle-unselected-handle-size: 16px;
  --mat-slide-toggle-unselected-icon-size: 16px;
  --mat-slide-toggle-unselected-pressed-handle-horizontal-margin: 0 2px;
  --mat-slide-toggle-unselected-with-icon-handle-horizontal-margin: 0 4px;
  --mat-slide-toggle-visible-track-opacity: 1;
  --mat-slide-toggle-visible-track-transition: opacity 75ms;
  --mat-slide-toggle-with-icon-handle-size: 24px;
  --mat-slide-toggle-touch-target-size: 48px;
  --mat-slide-toggle-disabled-label-text-color: #201a17;
  --mat-slide-toggle-disabled-selected-handle-color: #fff8f5;
  --mat-slide-toggle-disabled-selected-icon-color: #201a17;
  --mat-slide-toggle-disabled-selected-track-color: #201a17;
  --mat-slide-toggle-disabled-unselected-handle-color: #201a17;
  --mat-slide-toggle-disabled-unselected-icon-color: #f4ded3;
  --mat-slide-toggle-disabled-unselected-track-color: #f4ded3;
  --mat-slide-toggle-disabled-unselected-track-outline-color: #201a17;
  --mat-slide-toggle-label-text-color: #201a17;
  --mat-slide-toggle-selected-focus-handle-color: #ffdcc7;
  --mat-slide-toggle-selected-focus-state-layer-color: #964900;
  --mat-slide-toggle-selected-focus-state-layer-opacity: 0.12;
  --mat-slide-toggle-selected-focus-track-color: #964900;
  --mat-slide-toggle-selected-handle-color: #ffffff;
  --mat-slide-toggle-selected-hover-handle-color: #ffdcc7;
  --mat-slide-toggle-selected-hover-state-layer-color: #964900;
  --mat-slide-toggle-selected-hover-state-layer-opacity: 0.08;
  --mat-slide-toggle-selected-hover-track-color: #964900;
  --mat-slide-toggle-selected-icon-color: #723600;
  --mat-slide-toggle-selected-pressed-handle-color: #ffdcc7;
  --mat-slide-toggle-selected-pressed-state-layer-color: #964900;
  --mat-slide-toggle-selected-pressed-state-layer-opacity: 0.12;
  --mat-slide-toggle-selected-pressed-track-color: #964900;
  --mat-slide-toggle-selected-track-color: #964900;
  --mat-slide-toggle-track-outline-color: #84746a;
  --mat-slide-toggle-unselected-focus-handle-color: #52443c;
  --mat-slide-toggle-unselected-focus-state-layer-color: #201a17;
  --mat-slide-toggle-unselected-focus-state-layer-opacity: 0.12;
  --mat-slide-toggle-unselected-focus-track-color: #f4ded3;
  --mat-slide-toggle-unselected-handle-color: #84746a;
  --mat-slide-toggle-unselected-hover-handle-color: #52443c;
  --mat-slide-toggle-unselected-hover-state-layer-color: #201a17;
  --mat-slide-toggle-unselected-hover-state-layer-opacity: 0.08;
  --mat-slide-toggle-unselected-hover-track-color: #f4ded3;
  --mat-slide-toggle-unselected-icon-color: #f4ded3;
  --mat-slide-toggle-unselected-pressed-handle-color: #52443c;
  --mat-slide-toggle-unselected-pressed-state-layer-color: #201a17;
  --mat-slide-toggle-unselected-pressed-state-layer-opacity: 0.12;
  --mat-slide-toggle-unselected-pressed-track-color: #f4ded3;
  --mat-slide-toggle-unselected-track-color: #f4ded3;
  --mat-slide-toggle-touch-target-display: block;
  --mat-slide-toggle-label-text-font: Roboto, sans-serif;
  --mat-slide-toggle-label-text-line-height: 1.25rem;
  --mat-slide-toggle-label-text-size: 0.875rem;
  --mat-slide-toggle-label-text-tracking: 0.016rem;
  --mat-slide-toggle-label-text-weight: 400;
  --mat-radio-disabled-unselected-icon-opacity: 0.38;
  --mat-radio-disabled-selected-icon-opacity: 0.38;
  --mat-radio-touch-target-size: 48px;
  --mat-radio-checked-ripple-color: #964900;
  --mat-radio-disabled-label-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-radio-disabled-selected-icon-color: #201a17;
  --mat-radio-disabled-unselected-icon-color: #201a17;
  --mat-radio-label-text-color: #201a17;
  --mat-radio-ripple-color: #201a17;
  --mat-radio-selected-focus-icon-color: #964900;
  --mat-radio-selected-hover-icon-color: #964900;
  --mat-radio-selected-icon-color: #964900;
  --mat-radio-selected-pressed-icon-color: #964900;
  --mat-radio-unselected-focus-icon-color: #201a17;
  --mat-radio-unselected-hover-icon-color: #201a17;
  --mat-radio-unselected-icon-color: #52443c;
  --mat-radio-unselected-pressed-icon-color: #201a17;
  --mat-radio-touch-target-display: block;
  --mat-radio-state-layer-size: 40px;
  --mat-radio-label-text-font: Roboto, sans-serif;
  --mat-radio-label-text-line-height: 1.25rem;
  --mat-radio-label-text-size: 0.875rem;
  --mat-radio-label-text-tracking: 0.016rem;
  --mat-radio-label-text-weight: 400;
  --mat-slider-value-indicator-opacity: 1;
  --mat-slider-value-indicator-padding: 0;
  --mat-slider-value-indicator-width: 28px;
  --mat-slider-value-indicator-height: 28px;
  --mat-slider-value-indicator-caret-display: none;
  --mat-slider-value-indicator-border-radius: 50% 50% 50% 0;
  --mat-slider-value-indicator-text-transform: rotate(45deg);
  --mat-slider-value-indicator-container-transform: translateX(-50%) rotate(-45deg);
  --mat-slider-active-track-height: 4px;
  --mat-slider-handle-height: 20px;
  --mat-slider-handle-width: 20px;
  --mat-slider-inactive-track-height: 4px;
  --mat-slider-with-overlap-handle-outline-width: 1px;
  --mat-slider-with-tick-marks-active-container-opacity: 0.38;
  --mat-slider-with-tick-marks-container-size: 2px;
  --mat-slider-with-tick-marks-inactive-container-opacity: 0.38;
  --mat-slider-value-indicator-transform-origin: 0 28px;
  --mat-slider-active-track-color: #964900;
  --mat-slider-active-track-shape: 9999px;
  --mat-slider-disabled-active-track-color: #201a17;
  --mat-slider-disabled-handle-color: #201a17;
  --mat-slider-disabled-inactive-track-color: #201a17;
  --mat-slider-focus-handle-color: #964900;
  --mat-slider-focus-state-layer-color: color-mix(in srgb, #964900 20%, transparent);
  --mat-slider-handle-color: #964900;
  --mat-slider-handle-elevation: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-slider-handle-shape: 9999px;
  --mat-slider-hover-handle-color: #964900;
  --mat-slider-hover-state-layer-color: color-mix(in srgb, #964900 5%, transparent);
  --mat-slider-inactive-track-color: #f4ded3;
  --mat-slider-inactive-track-shape: 9999px;
  --mat-slider-label-container-color: #964900;
  --mat-slider-label-label-text-color: #ffffff;
  --mat-slider-ripple-color: #964900;
  --mat-slider-with-overlap-handle-outline-color: #ffffff;
  --mat-slider-with-tick-marks-active-container-color: #ffffff;
  --mat-slider-with-tick-marks-container-shape: 9999px;
  --mat-slider-with-tick-marks-disabled-container-color: #201a17;
  --mat-slider-with-tick-marks-inactive-container-color: #52443c;
  --mat-slider-label-label-text-font: Roboto, sans-serif;
  --mat-slider-label-label-text-line-height: 1rem;
  --mat-slider-label-label-text-size: 0.75rem;
  --mat-slider-label-label-text-tracking: 0.031rem;
  --mat-slider-label-label-text-weight: 500;
  --mat-menu-divider-bottom-spacing: 8px;
  --mat-menu-divider-top-spacing: 8px;
  --mat-menu-item-icon-size: 24px;
  --mat-menu-item-spacing: 12px;
  --mat-menu-item-leading-spacing: 12px;
  --mat-menu-item-trailing-spacing: 12px;
  --mat-menu-item-with-icon-leading-spacing: 12px;
  --mat-menu-item-with-icon-trailing-spacing: 12px;
  --mat-menu-container-shape: 4px;
  --mat-menu-divider-color: #f4ded3;
  --mat-menu-item-label-text-color: #201a17;
  --mat-menu-item-icon-color: #52443c;
  --mat-menu-item-hover-state-layer-color: color-mix(in srgb, #201a17 8%, transparent);
  --mat-menu-item-focus-state-layer-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-menu-container-color: #f8ebe6;
  --mat-menu-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-menu-item-label-text-font: Roboto, sans-serif;
  --mat-menu-item-label-text-line-height: 1.25rem;
  --mat-menu-item-label-text-size: 0.875rem;
  --mat-menu-item-label-text-tracking: 0.006rem;
  --mat-menu-item-label-text-weight: 500;
  --mat-list-active-indicator-color: #ffdcc7;
  --mat-list-active-indicator-shape: 9999px;
  --mat-list-list-item-container-color: transparent;
  --mat-list-list-item-container-shape: 0;
  --mat-list-list-item-disabled-label-text-color: #201a17;
  --mat-list-list-item-disabled-label-text-opacity: 0.3;
  --mat-list-list-item-disabled-leading-icon-color: #201a17;
  --mat-list-list-item-disabled-leading-icon-opacity: 0.38;
  --mat-list-list-item-disabled-state-layer-color: #201a17;
  --mat-list-list-item-disabled-state-layer-opacity: 0.12;
  --mat-list-list-item-disabled-trailing-icon-color: #201a17;
  --mat-list-list-item-disabled-trailing-icon-opacity: 0.38;
  --mat-list-list-item-focus-label-text-color: #201a17;
  --mat-list-list-item-focus-state-layer-color: #201a17;
  --mat-list-list-item-focus-state-layer-opacity: 0.12;
  --mat-list-list-item-hover-label-text-color: #201a17;
  --mat-list-list-item-hover-state-layer-color: #201a17;
  --mat-list-list-item-hover-state-layer-opacity: 0.08;
  --mat-list-list-item-label-text-color: #201a17;
  --mat-list-list-item-leading-avatar-color: #ffdcc7;
  --mat-list-list-item-leading-avatar-shape: 9999px;
  --mat-list-list-item-leading-avatar-size: 40px;
  --mat-list-list-item-leading-icon-color: #52443c;
  --mat-list-list-item-leading-icon-size: 24px;
  --mat-list-list-item-selected-trailing-icon-color: #964900;
  --mat-list-list-item-supporting-text-color: #52443c;
  --mat-list-list-item-trailing-icon-color: #52443c;
  --mat-list-list-item-trailing-icon-size: 24px;
  --mat-list-list-item-trailing-supporting-text-color: #52443c;
  --mat-list-list-item-leading-icon-start-space: 16px;
  --mat-list-list-item-leading-icon-end-space: 16px;
  --mat-list-list-item-one-line-container-height: 48px;
  --mat-list-list-item-two-line-container-height: 64px;
  --mat-list-list-item-three-line-container-height: 88px;
  --mat-list-list-item-label-text-font: Roboto, sans-serif;
  --mat-list-list-item-label-text-line-height: 1.5rem;
  --mat-list-list-item-label-text-size: 1rem;
  --mat-list-list-item-label-text-tracking: 0.031rem;
  --mat-list-list-item-label-text-weight: 400;
  --mat-list-list-item-supporting-text-font: Roboto, sans-serif;
  --mat-list-list-item-supporting-text-line-height: 1.25rem;
  --mat-list-list-item-supporting-text-size: 0.875rem;
  --mat-list-list-item-supporting-text-tracking: 0.016rem;
  --mat-list-list-item-supporting-text-weight: 400;
  --mat-list-list-item-trailing-supporting-text-font: Roboto, sans-serif;
  --mat-list-list-item-trailing-supporting-text-line-height: 1rem;
  --mat-list-list-item-trailing-supporting-text-size: 0.688rem;
  --mat-list-list-item-trailing-supporting-text-tracking: 0.031rem;
  --mat-list-list-item-trailing-supporting-text-weight: 500;
  --mat-paginator-page-size-select-width: 84px;
  --mat-paginator-page-size-select-touch-target-height: 48px;
  --mat-paginator-container-text-color: #201a17;
  --mat-paginator-container-background-color: #fff8f5;
  --mat-paginator-disabled-icon-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-paginator-enabled-icon-color: #52443c;
  --mat-paginator-container-size: 56px;
  --mat-paginator-form-field-container-height: 40px;
  --mat-paginator-form-field-container-vertical-padding: 8px;
  --mat-paginator-touch-target-display: block;
  --mat-paginator-container-text-font: Roboto, sans-serif;
  --mat-paginator-container-text-line-height: 1rem;
  --mat-paginator-container-text-size: 0.75rem;
  --mat-paginator-container-text-tracking: 0.025rem;
  --mat-paginator-container-text-weight: 400;
  --mat-paginator-select-trigger-text-size: 0.75rem;
  --mat-tab-active-indicator-height: 2px;
  --mat-tab-active-indicator-shape: 0;
  --mat-tab-divider-height: 1px;
  --mat-tab-active-focus-indicator-color: #964900;
  --mat-tab-active-focus-label-text-color: #201a17;
  --mat-tab-active-hover-indicator-color: #964900;
  --mat-tab-active-hover-label-text-color: #201a17;
  --mat-tab-active-indicator-color: #964900;
  --mat-tab-active-label-text-color: #201a17;
  --mat-tab-active-ripple-color: #201a17;
  --mat-tab-divider-color: #f4ded3;
  --mat-tab-inactive-focus-label-text-color: #201a17;
  --mat-tab-inactive-hover-label-text-color: #201a17;
  --mat-tab-inactive-label-text-color: #201a17;
  --mat-tab-inactive-ripple-color: #201a17;
  --mat-tab-pagination-icon-color: #201a17;
  --mat-tab-disabled-ripple-color: #52443c;
  --mat-tab-container-height: 48px;
  --mat-tab-label-text-font: Roboto, sans-serif;
  --mat-tab-label-text-line-height: 1.25rem;
  --mat-tab-label-text-size: 0.875rem;
  --mat-tab-label-text-tracking: 0.006rem;
  --mat-tab-label-text-weight: 500;
  --mat-checkbox-selected-focus-state-layer-opacity: 0.12;
  --mat-checkbox-selected-hover-state-layer-opacity: 0.08;
  --mat-checkbox-selected-pressed-state-layer-opacity: 0.12;
  --mat-checkbox-unselected-focus-state-layer-opacity: 0.12;
  --mat-checkbox-unselected-hover-state-layer-opacity: 0.08;
  --mat-checkbox-unselected-pressed-state-layer-opacity: 0.12;
  --mat-checkbox-touch-target-size: 48px;
  --mat-checkbox-disabled-label-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-checkbox-disabled-selected-checkmark-color: #fff8f5;
  --mat-checkbox-disabled-selected-icon-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-checkbox-disabled-unselected-icon-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-checkbox-label-text-color: #201a17;
  --mat-checkbox-selected-checkmark-color: #ffffff;
  --mat-checkbox-selected-focus-icon-color: #964900;
  --mat-checkbox-selected-focus-state-layer-color: #964900;
  --mat-checkbox-selected-hover-icon-color: #964900;
  --mat-checkbox-selected-hover-state-layer-color: #964900;
  --mat-checkbox-selected-icon-color: #964900;
  --mat-checkbox-selected-pressed-icon-color: #964900;
  --mat-checkbox-selected-pressed-state-layer-color: #201a17;
  --mat-checkbox-unselected-focus-icon-color: #201a17;
  --mat-checkbox-unselected-focus-state-layer-color: #201a17;
  --mat-checkbox-unselected-hover-icon-color: #201a17;
  --mat-checkbox-unselected-hover-state-layer-color: #201a17;
  --mat-checkbox-unselected-icon-color: #52443c;
  --mat-checkbox-unselected-pressed-state-layer-color: #964900;
  --mat-checkbox-touch-target-display: block;
  --mat-checkbox-state-layer-size: 40px;
  --mat-checkbox-label-text-font: Roboto, sans-serif;
  --mat-checkbox-label-text-line-height: 1.25rem;
  --mat-checkbox-label-text-size: 0.875rem;
  --mat-checkbox-label-text-tracking: 0.016rem;
  --mat-checkbox-label-text-weight: 400;
  --mat-button-filled-container-shape: 9999px;
  --mat-button-filled-horizontal-padding: 24px;
  --mat-button-filled-icon-offset: -8px;
  --mat-button-filled-icon-spacing: 8px;
  --mat-button-filled-touch-target-size: 48px;
  --mat-button-outlined-container-shape: 9999px;
  --mat-button-outlined-horizontal-padding: 24px;
  --mat-button-outlined-icon-offset: -8px;
  --mat-button-outlined-icon-spacing: 8px;
  --mat-button-outlined-outline-width: 1px;
  --mat-button-outlined-touch-target-size: 48px;
  --mat-button-protected-container-shape: 9999px;
  --mat-button-protected-horizontal-padding: 24px;
  --mat-button-protected-icon-offset: -8px;
  --mat-button-protected-icon-spacing: 8px;
  --mat-button-protected-touch-target-size: 48px;
  --mat-button-text-container-shape: 9999px;
  --mat-button-text-horizontal-padding: 12px;
  --mat-button-text-icon-offset: -4px;
  --mat-button-text-icon-spacing: 8px;
  --mat-button-text-with-icon-horizontal-padding: 16px;
  --mat-button-text-touch-target-size: 48px;
  --mat-button-tonal-container-shape: 9999px;
  --mat-button-tonal-horizontal-padding: 24px;
  --mat-button-tonal-icon-offset: -8px;
  --mat-button-tonal-icon-spacing: 8px;
  --mat-button-tonal-touch-target-size: 48px;
  --mat-button-filled-container-color: #964900;
  --mat-button-filled-disabled-container-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-button-filled-disabled-label-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-button-filled-disabled-state-layer-color: #52443c;
  --mat-button-filled-focus-state-layer-opacity: 0.12;
  --mat-button-filled-hover-state-layer-opacity: 0.08;
  --mat-button-filled-label-text-color: #ffffff;
  --mat-button-filled-pressed-state-layer-opacity: 0.12;
  --mat-button-filled-ripple-color: color-mix(in srgb, #ffffff 12%, transparent);
  --mat-button-filled-state-layer-color: #ffffff;
  --mat-button-outlined-disabled-label-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-button-outlined-disabled-outline-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-button-outlined-disabled-state-layer-color: #52443c;
  --mat-button-outlined-focus-state-layer-opacity: 0.12;
  --mat-button-outlined-hover-state-layer-opacity: 0.08;
  --mat-button-outlined-label-text-color: #964900;
  --mat-button-outlined-outline-color: #84746a;
  --mat-button-outlined-pressed-state-layer-opacity: 0.12;
  --mat-button-outlined-ripple-color: color-mix(in srgb, #964900 12%, transparent);
  --mat-button-outlined-state-layer-color: #964900;
  --mat-button-protected-container-color: #fff8f5;
  --mat-button-protected-container-elevation-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-disabled-container-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-button-protected-disabled-container-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-disabled-label-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-button-protected-disabled-state-layer-color: #52443c;
  --mat-button-protected-focus-container-elevation-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-focus-state-layer-opacity: 0.12;
  --mat-button-protected-hover-container-elevation-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-hover-state-layer-opacity: 0.08;
  --mat-button-protected-label-text-color: #964900;
  --mat-button-protected-pressed-container-elevation-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  --mat-button-protected-pressed-state-layer-opacity: 0.12;
  --mat-button-protected-ripple-color: color-mix(in srgb, #964900 12%, transparent);
  --mat-button-protected-state-layer-color: #964900;
  --mat-button-text-disabled-label-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-button-text-disabled-state-layer-color: #52443c;
  --mat-button-text-focus-state-layer-opacity: 0.12;
  --mat-button-text-hover-state-layer-opacity: 0.08;
  --mat-button-text-label-text-color: #964900;
  --mat-button-text-pressed-state-layer-opacity: 0.12;
  --mat-button-text-ripple-color: color-mix(in srgb, #964900 12%, transparent);
  --mat-button-text-state-layer-color: #964900;
  --mat-button-tonal-container-color: #ffdcc7;
  --mat-button-tonal-disabled-container-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-button-tonal-disabled-label-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-button-tonal-disabled-state-layer-color: #52443c;
  --mat-button-tonal-focus-state-layer-opacity: 0.12;
  --mat-button-tonal-hover-state-layer-opacity: 0.08;
  --mat-button-tonal-label-text-color: #5b4130;
  --mat-button-tonal-pressed-state-layer-opacity: 0.12;
  --mat-button-tonal-ripple-color: color-mix(in srgb, #5b4130 12%, transparent);
  --mat-button-tonal-state-layer-color: #5b4130;
  --mat-button-filled-touch-target-display: block;
  --mat-button-filled-container-height: 40px;
  --mat-button-outlined-container-height: 40px;
  --mat-button-outlined-touch-target-display: block;
  --mat-button-protected-touch-target-display: block;
  --mat-button-protected-container-height: 40px;
  --mat-button-text-touch-target-display: block;
  --mat-button-text-container-height: 40px;
  --mat-button-tonal-container-height: 40px;
  --mat-button-tonal-touch-target-display: block;
  --mat-button-filled-label-text-font: Roboto, sans-serif;
  --mat-button-filled-label-text-size: 0.875rem;
  --mat-button-filled-label-text-tracking: 0.006rem;
  --mat-button-filled-label-text-weight: 500;
  --mat-button-outlined-label-text-font: Roboto, sans-serif;
  --mat-button-outlined-label-text-size: 0.875rem;
  --mat-button-outlined-label-text-tracking: 0.006rem;
  --mat-button-outlined-label-text-weight: 500;
  --mat-button-protected-label-text-font: Roboto, sans-serif;
  --mat-button-protected-label-text-size: 0.875rem;
  --mat-button-protected-label-text-tracking: 0.006rem;
  --mat-button-protected-label-text-weight: 500;
  --mat-button-text-label-text-font: Roboto, sans-serif;
  --mat-button-text-label-text-size: 0.875rem;
  --mat-button-text-label-text-tracking: 0.006rem;
  --mat-button-text-label-text-weight: 500;
  --mat-button-tonal-label-text-font: Roboto, sans-serif;
  --mat-button-tonal-label-text-size: 0.875rem;
  --mat-button-tonal-label-text-tracking: 0.006rem;
  --mat-button-tonal-label-text-weight: 500;
  --mat-icon-button-icon-size: 24px;
  --mat-icon-button-container-shape: 9999px;
  --mat-icon-button-touch-target-size: 48px;
  --mat-icon-button-disabled-icon-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-icon-button-disabled-state-layer-color: #52443c;
  --mat-icon-button-focus-state-layer-opacity: 0.12;
  --mat-icon-button-hover-state-layer-opacity: 0.08;
  --mat-icon-button-icon-color: #52443c;
  --mat-icon-button-pressed-state-layer-opacity: 0.12;
  --mat-icon-button-ripple-color: color-mix(in srgb, #52443c 12%, transparent);
  --mat-icon-button-state-layer-color: #52443c;
  --mat-icon-button-touch-target-display: block;
  --mat-icon-button-state-layer-size: 40px;
  --mat-fab-container-shape: 16px;
  --mat-fab-extended-container-height: 56px;
  --mat-fab-extended-container-shape: 16px;
  --mat-fab-small-container-shape: 12px;
  --mat-fab-touch-target-size: 48px;
  --mat-fab-small-touch-target-size: 48px;
  --mat-fab-container-color: #ffdcc7;
  --mat-fab-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-disabled-state-container-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-fab-disabled-state-foreground-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-fab-extended-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-focus-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-extended-pressed-container-elevation-shadow: 6;
  --mat-fab-focus-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-focus-state-layer-opacity: 0.12;
  --mat-fab-foreground-color: #723600;
  --mat-fab-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-hover-state-layer-opacity: 0.08;
  --mat-fab-pressed-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-pressed-state-layer-opacity: 0.12;
  --mat-fab-ripple-color: color-mix(in srgb, #723600 12%, transparent);
  --mat-fab-small-container-color: #ffdcc7;
  --mat-fab-small-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-small-disabled-state-container-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-fab-small-disabled-state-foreground-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-fab-small-focus-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-small-focus-state-layer-opacity: 0.12;
  --mat-fab-small-foreground-color: #723600;
  --mat-fab-small-hover-container-elevation-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  --mat-fab-small-hover-state-layer-opacity: 0.08;
  --mat-fab-small-pressed-container-elevation-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  --mat-fab-small-pressed-state-layer-opacity: 0.12;
  --mat-fab-small-ripple-color: color-mix(in srgb, #723600 12%, transparent);
  --mat-fab-small-state-layer-color: #723600;
  --mat-fab-state-layer-color: #723600;
  --mat-fab-touch-target-display: block;
  --mat-fab-extended-label-text-font: Roboto, sans-serif;
  --mat-fab-extended-label-text-size: 0.875rem;
  --mat-fab-extended-label-text-tracking: 0.006rem;
  --mat-fab-extended-label-text-weight: 500;
  --mat-snack-bar-container-shape: 4px;
  --mat-snack-bar-button-color: #ffb787;
  --mat-snack-bar-container-color: #362f2b;
  --mat-snack-bar-supporting-text-color: #fbeee8;
  --mat-snack-bar-supporting-text-font: Roboto, sans-serif;
  --mat-snack-bar-supporting-text-line-height: 1.25rem;
  --mat-snack-bar-supporting-text-size: 0.875rem;
  --mat-snack-bar-supporting-text-weight: 400;
  --mat-table-row-item-outline-width: 1px;
  --mat-table-background-color: #fff8f5;
  --mat-table-header-headline-color: #201a17;
  --mat-table-row-item-label-text-color: #201a17;
  --mat-table-row-item-outline-color: #84746a;
  --mat-table-header-container-height: 56px;
  --mat-table-footer-container-height: 52px;
  --mat-table-row-item-container-height: 52px;
  --mat-table-header-headline-font: Roboto, sans-serif;
  --mat-table-header-headline-line-height: 1.25rem;
  --mat-table-header-headline-size: 0.875rem;
  --mat-table-header-headline-tracking: 0.006rem;
  --mat-table-header-headline-weight: 500;
  --mat-table-row-item-label-text-font: Roboto, sans-serif;
  --mat-table-row-item-label-text-line-height: 1.25rem;
  --mat-table-row-item-label-text-size: 0.875rem;
  --mat-table-row-item-label-text-tracking: 0.016rem;
  --mat-table-row-item-label-text-weight: 400;
  --mat-table-footer-supporting-text-font: Roboto, sans-serif;
  --mat-table-footer-supporting-text-line-height: 1.25rem;
  --mat-table-footer-supporting-text-size: 0.875rem;
  --mat-table-footer-supporting-text-tracking: 0.016rem;
  --mat-table-footer-supporting-text-weight: 400;
  --mat-progress-spinner-size: 48px;
  --mat-progress-spinner-active-indicator-width: 4px;
  --mat-progress-spinner-active-indicator-color: #964900;
  --mat-badge-container-offset: -12px 0;
  --mat-badge-container-overlap-offset: -12px;
  --mat-badge-container-padding: 0 4px;
  --mat-badge-container-shape: 9999px;
  --mat-badge-container-size: 16px;
  --mat-badge-large-size-container-offset: -12px 0;
  --mat-badge-large-size-container-overlap-offset: -12px;
  --mat-badge-large-size-container-padding: 0 4px;
  --mat-badge-large-size-container-size: 16px;
  --mat-badge-legacy-container-size: unset;
  --mat-badge-legacy-large-size-container-size: unset;
  --mat-badge-legacy-small-size-container-size: unset;
  --mat-badge-small-size-container-offset: -6px 0;
  --mat-badge-small-size-container-overlap-offset: -6px;
  --mat-badge-small-size-container-padding: 0;
  --mat-badge-small-size-container-size: 6px;
  --mat-badge-background-color: #ba1a1a;
  --mat-badge-disabled-state-background-color: color-mix(in srgb, #ba1a1a 38%, transparent);
  --mat-badge-disabled-state-text-color: #ffffff;
  --mat-badge-text-color: #ffffff;
  --mat-badge-large-size-line-height: 16px;
  --mat-badge-large-size-text-size: 0.688rem;
  --mat-badge-line-height: 16px;
  --mat-badge-small-size-line-height: 6px;
  --mat-badge-small-size-text-size: 0;
  --mat-badge-text-font: Roboto, sans-serif;
  --mat-badge-text-size: 0.688rem;
  --mat-badge-text-weight: 500;
  --mat-bottom-sheet-container-shape: 28px;
  --mat-bottom-sheet-container-text-color: #201a17;
  --mat-bottom-sheet-container-background-color: #fef1ec;
  --mat-bottom-sheet-container-text-font: Roboto, sans-serif;
  --mat-bottom-sheet-container-text-line-height: 1.5rem;
  --mat-bottom-sheet-container-text-size: 1rem;
  --mat-bottom-sheet-container-text-tracking: 0.031rem;
  --mat-bottom-sheet-container-text-weight: 400;
  --mat-button-toggle-focus-state-layer-opacity: 0.12;
  --mat-button-toggle-hover-state-layer-opacity: 0.08;
  --mat-button-toggle-shape: 28px;
  --mat-button-toggle-background-color: transparent;
  --mat-button-toggle-disabled-selected-state-background-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-button-toggle-disabled-selected-state-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-button-toggle-disabled-state-background-color: transparent;
  --mat-button-toggle-disabled-state-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-button-toggle-divider-color: #84746a;
  --mat-button-toggle-selected-state-background-color: #ffdcc7;
  --mat-button-toggle-selected-state-text-color: #5b4130;
  --mat-button-toggle-state-layer-color: #201a17;
  --mat-button-toggle-text-color: #201a17;
  --mat-button-toggle-height: 40px;
  --mat-button-toggle-label-text-font: Roboto, sans-serif;
  --mat-button-toggle-label-text-line-height: 1.25rem;
  --mat-button-toggle-label-text-size: 0.875rem;
  --mat-button-toggle-label-text-tracking: 0.006rem;
  --mat-button-toggle-label-text-weight: 500;
  --mat-datepicker-calendar-container-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-container-shape: 16px;
  --mat-datepicker-calendar-container-touch-elevation-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  --mat-datepicker-calendar-container-touch-shape: 28px;
  --mat-datepicker-calendar-body-label-text-color: #201a17;
  --mat-datepicker-calendar-container-background-color: #f2e6e1;
  --mat-datepicker-calendar-container-text-color: #201a17;
  --mat-datepicker-calendar-date-disabled-state-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-datepicker-calendar-date-focus-state-background-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-datepicker-calendar-date-hover-state-background-color: color-mix(in srgb, #201a17 8%, transparent);
  --mat-datepicker-calendar-date-in-comparison-range-state-background-color: #ffd9e1;
  --mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color: #755846;
  --mat-datepicker-calendar-date-in-overlap-range-state-background-color: #ffdcc7;
  --mat-datepicker-calendar-date-in-range-state-background-color: #ffdcc7;
  --mat-datepicker-calendar-date-outline-color: transparent;
  --mat-datepicker-calendar-date-preview-state-outline-color: #964900;
  --mat-datepicker-calendar-date-selected-disabled-state-background-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-datepicker-calendar-date-selected-state-background-color: #964900;
  --mat-datepicker-calendar-date-selected-state-text-color: #ffffff;
  --mat-datepicker-calendar-date-text-color: #201a17;
  --mat-datepicker-calendar-date-today-disabled-state-outline-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-datepicker-calendar-date-today-outline-color: #964900;
  --mat-datepicker-calendar-date-today-selected-state-outline-color: #964900;
  --mat-datepicker-calendar-header-divider-color: transparent;
  --mat-datepicker-calendar-header-text-color: #52443c;
  --mat-datepicker-calendar-navigation-button-icon-color: #52443c;
  --mat-datepicker-calendar-period-button-icon-color: #52443c;
  --mat-datepicker-calendar-period-button-text-color: #52443c;
  --mat-datepicker-range-input-disabled-state-separator-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-datepicker-range-input-disabled-state-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-datepicker-range-input-separator-color: #201a17;
  --mat-datepicker-toggle-active-state-icon-color: #964900;
  --mat-datepicker-toggle-icon-color: #52443c;
  --mat-datepicker-calendar-body-label-text-size: 0.875rem;
  --mat-datepicker-calendar-body-label-text-weight: 500;
  --mat-datepicker-calendar-header-text-size: 0.875rem;
  --mat-datepicker-calendar-header-text-weight: 500;
  --mat-datepicker-calendar-period-button-text-size: 0.875rem;
  --mat-datepicker-calendar-period-button-text-weight: 500;
  --mat-datepicker-calendar-text-font: Roboto, sans-serif;
  --mat-datepicker-calendar-text-size: 0.875rem;
  --mat-divider-width: 1px;
  --mat-divider-color: #d7c3b8;
  --mat-expansion-container-shape: 12px;
  --mat-expansion-header-indicator-display: inline-block;
  --mat-expansion-legacy-header-indicator-display: none;
  --mat-expansion-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  --mat-expansion-actions-divider-color: #84746a;
  --mat-expansion-container-background-color: #fff8f5;
  --mat-expansion-container-text-color: #201a17;
  --mat-expansion-header-description-color: #52443c;
  --mat-expansion-header-disabled-state-text-color: color-mix(in srgb, #201a17 38%, transparent);
  --mat-expansion-header-focus-state-layer-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-expansion-header-hover-state-layer-color: color-mix(in srgb, #201a17 8%, transparent);
  --mat-expansion-header-indicator-color: #52443c;
  --mat-expansion-header-text-color: #201a17;
  --mat-expansion-header-collapsed-state-height: 48px;
  --mat-expansion-header-expanded-state-height: 64px;
  --mat-expansion-container-text-font: Roboto, sans-serif;
  --mat-expansion-container-text-line-height: 1.5rem;
  --mat-expansion-container-text-size: 1rem;
  --mat-expansion-container-text-tracking: 0.031rem;
  --mat-expansion-container-text-weight: 400;
  --mat-expansion-header-text-font: Roboto, sans-serif;
  --mat-expansion-header-text-line-height: 1.5rem;
  --mat-expansion-header-text-size: 1rem;
  --mat-expansion-header-text-tracking: 0.009rem;
  --mat-expansion-header-text-weight: 500;
  --mat-grid-list-tile-header-primary-text-size: 400 1rem / 1.5rem Roboto, sans-serif;
  --mat-grid-list-tile-header-secondary-text-size: 400 0.875rem / 1.25rem Roboto, sans-serif;
  --mat-grid-list-tile-footer-primary-text-size: 400 1rem / 1.5rem Roboto, sans-serif;
  --mat-grid-list-tile-footer-secondary-text-size: 400 0.875rem / 1.25rem Roboto, sans-serif;
  --mat-icon-color: inherit;
  --mat-sidenav-container-shape: 16px;
  --mat-sidenav-container-elevation-shadow: none;
  --mat-sidenav-container-width: 360px;
  --mat-sidenav-container-divider-color: transparent;
  --mat-sidenav-container-background-color: #fff8f5;
  --mat-sidenav-container-text-color: #52443c;
  --mat-sidenav-content-background-color: #fff8f5;
  --mat-sidenav-content-text-color: #201a17;
  --mat-sidenav-scrim-color: color-mix(in srgb, #3a2e26 40%, transparent);
  --mat-stepper-header-error-state-icon-background-color: transparent;
  --mat-stepper-header-focus-state-layer-shape: 12px;
  --mat-stepper-header-hover-state-layer-shape: 12px;
  --mat-stepper-container-color: #fff8f5;
  --mat-stepper-header-done-state-icon-background-color: #964900;
  --mat-stepper-header-done-state-icon-foreground-color: #ffffff;
  --mat-stepper-header-edit-state-icon-background-color: #964900;
  --mat-stepper-header-edit-state-icon-foreground-color: #ffffff;
  --mat-stepper-header-error-state-icon-foreground-color: #ba1a1a;
  --mat-stepper-header-error-state-label-text-color: #ba1a1a;
  --mat-stepper-header-focus-state-layer-color: color-mix(in srgb, #201a17 12%, transparent);
  --mat-stepper-header-hover-state-layer-color: color-mix(in srgb, #201a17 8%, transparent);
  --mat-stepper-header-icon-background-color: #52443c;
  --mat-stepper-header-icon-foreground-color: #fff8f5;
  --mat-stepper-header-label-text-color: #52443c;
  --mat-stepper-header-optional-label-text-color: #52443c;
  --mat-stepper-header-selected-state-icon-background-color: #964900;
  --mat-stepper-header-selected-state-icon-foreground-color: #ffffff;
  --mat-stepper-header-selected-state-label-text-color: #52443c;
  --mat-stepper-line-color: #84746a;
  --mat-stepper-header-height: 72px;
  --mat-stepper-container-text-font: Roboto, sans-serif;
  --mat-stepper-header-label-text-font: Roboto, sans-serif;
  --mat-stepper-header-label-text-size: 0.875rem;
  --mat-stepper-header-label-text-weight: 500;
  --mat-stepper-header-error-state-label-text-size: 0.875rem;
  --mat-stepper-header-selected-state-label-text-size: 0.875rem;
  --mat-stepper-header-selected-state-label-text-weight: 500;
  --mat-stepper-header-height: 72px;
  --mat-sort-arrow-color: #201a17;
  --mat-toolbar-container-background-color: #fff8f5;
  --mat-toolbar-container-text-color: #201a17;
  --mat-toolbar-standard-height: 64px;
  --mat-toolbar-mobile-height: 56px;
  --mat-toolbar-title-text-font: Roboto, sans-serif;
  --mat-toolbar-title-text-line-height: 1.75rem;
  --mat-toolbar-title-text-size: 1.375rem;
  --mat-toolbar-title-text-tracking: 0;
  --mat-toolbar-title-text-weight: 400;
  --mat-tree-container-background-color: #fff8f5;
  --mat-tree-node-text-color: #201a17;
  --mat-tree-node-min-height: 48px;
  --mat-tree-node-text-font: Roboto, sans-serif;
  --mat-tree-node-text-size: 1rem;
  --mat-tree-node-text-weight: 400;
  --mat-timepicker-container-shape: 4px;
  --mat-timepicker-container-background-color: #f8ebe6;
  --mat-timepicker-container-elevation-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

:root {
  --ion-color-gray-light: #f5f5f5;
  --ion-color-gray-dark: #d4d4d4;
  --ion-color-gray-darkest: #1f1b1c;
  --ion-color-black: #012734;
  --ion-color-gold: #a38a5f;
  --randy-red: #DD2E4E;
  --randy-red-dark: #DD2E4E;
  --randy-gray: #41403B;
  --randy-gray-dark: #2d2d2d;
  --randy-beige: #FFF5E0;
  --randy-beige-dark: #EAE5DD;
  --randy-border: #CCCCCC;
  --quantity-selector-border-width: 2px;
  --quantity-selector-border-color: var(--ion-color-primary);
  --quantity-selector-height: 40px;
  --quantity-selector-background: white;
  --quantity-selector-text-color: var(--ion-color-primary);
  --home-preorder-type-button-background: var(--ion-color-primary);
  --preorder-type-chip-border-color: white;
  --payment-modal-item-background: white;
  --payment-modal-checkbox-color: black;
}

.ion-color-black {
  --ion-color-base: var(--ion-color-black);
  --ion-color-base-rgb: var(--ion-color-black);
  --ion-color-contrast: var(--ion-color-main-contrast);
  --ion-color-contrast-rgb: var(--ion-color-main-contrast-rgb);
  --ion-color-shade: var(--ion-color-main-shade);
  --ion-color-tint: var(--ion-color-main-tint);
}

p,
h1,
h2 {
  margin: unset;
}

.top-toolbar {
  background: var(--randy-beige);
  padding: 16px 20px;
}
.top-toolbar .toolbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top-toolbar .brand-logo {
  width: 80px;
  height: auto;
  cursor: pointer;
}
.top-toolbar .menu-icon {
  font-size: 32px;
  color: var(--randy-gray);
  cursor: pointer;
}

.category-tabs-block {
  background: white;
}

ion-content {
  background: var(--randy-beige) !important;
}

.articles-content {
  --background: var(--randy-beige);
  background: var(--randy-beige);
}

.main {
  overflow: auto;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}
.center ion-spinner {
  --color: var(--randy-red);
  width: 48px;
  height: 48px;
}

.item-card {
  width: 100%;
}

.articles-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
@media (min-width: 991px) {
  .articles-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 24px;
  }
}

ion-searchbar {
  --placeholder-color: var(--randy-gray);
  --placeholder-opacity: 0.6;
  --color: var(--randy-gray);
  --icon-color: var(--randy-gray);
  --border-radius: 8px;
  --background: white;
  --box-shadow: none;
  border: 2px solid var(--randy-border);
  border-radius: 8px;
}
@media (min-width: 991px) {
  ion-searchbar {
    width: auto;
  }
}

.items-wrap {
  padding: 32px 20px;
}
.items-wrap:first-of-type {
  padding-top: 24px;
}

.category-header-wrap {
  margin-bottom: 24px;
}

.category-title {
  font-family: AppFontBold;
  font-size: 32px;
  line-height: 40px;
  color: var(--randy-gray);
  margin-bottom: 8px;
}

.category-subtitle {
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 22px;
  color: var(--randy-red);
}

.main-row {
  height: 100%;
  overflow: hidden;
}

app-order-content {
  display: block;
  height: 100%;
}

.order-col {
  min-width: 380px;
}

ion-footer {
  background: var(--randy-beige);
  padding: 16px 20px 24px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
}

@media (min-width: 991px) {
  .footer-btn {
    display: none;
  }
}

.category-list {
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.3s ease;
  opacity: 1;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  background-color: var(--randy-beige);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  padding: 16px 20px;
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list .category {
  flex: 0 0 auto;
}

.search-block {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  background: white;
  opacity: 1;
  transition: 0.3s ease;
}

.hidden {
  opacity: 0;
  display: none;
  transition: 0.3s ease;
}

.main-row {
  height: 100%;
  overflow: hidden;
}

ion-chip {
  height: 44px;
  background: var(--randy-beige);
  border: 2px solid var(--randy-red);
  transition: all 0.2s ease;
  min-width: 44px;
  padding: 0 20px !important;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-chip ion-label {
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  color: var(--randy-gray);
  font-family: AppFont;
  white-space: nowrap;
}
ion-chip.selected {
  background: var(--randy-red);
  border-color: var(--randy-red);
}
ion-chip.selected ion-label {
  color: white;
}
ion-chip.chip-icon {
  min-width: 44px;
  width: 44px;
  padding: 0 !important;
  border: 2px solid var(--randy-red);
}
ion-chip.chip-icon .icon {
  font-size: 20px;
  color: var(--randy-gray);
  margin: 0;
}

.service-not-available-container {
  --padding-start: 20px !important;
  --padding-end: 10px;
  --padding-top: 10px;
  --padding-bottom: 10px;
}
.service-not-available-container ion-icon {
  color: #fff !important;
}

.allergen-banner-col {
  background: var(--randy-beige);
}

.allergen-banner {
  background: rgba(65, 64, 59, 0.5019607843);
  padding: 12px 20px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding-left: 30px;
}
.allergen-banner .info-icon {
  width: 27px !important;
  color: white;
  font-size: 24px;
  flex-shrink: 0;
  right: auto;
  left: 0;
  bottom: 9px;
}
@media (max-width: 992px) {
  .allergen-banner .info-icon {
    bottom: 16px;
  }
}
.allergen-banner .info {
  flex: 1;
  font-family: AppFont;
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  color: white;
}
.allergen-banner .info a.link-red {
  color: var(--randy-red);
  text-decoration: underline;
  font-weight: 600;
}

.expand-block {
  position: fixed;
  height: 100vh;
  width: 100vw;
  right: -100%;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
  z-index: 10;
}
@media (max-width: 992px) {
  .expand-block {
    display: none;
  }
}
.expand-block.show {
  right: 0%;
}

.sidebar {
  position: fixed;
  right: -100%;
  top: 0;
  width: 420px;
  max-width: 90vw;
  height: 100vh;
  background: white;
  z-index: 11;
  display: flex;
  flex-direction: column;
  transition: right 0.3s ease-in-out;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.15);
}
@media (max-width: 992px) {
  .sidebar {
    display: none;
  }
}
.sidebar.show {
  right: 0%;
}

app-order-content {
  display: block;
  height: 100%;
  background: var(--randy-beige);
}

.burger_block {
  display: flex;
  align-items: center;
}
.burger_block .basket_version {
  position: relative;
  display: flex;
  justify-content: center;
}
.burger_block .basket_version ion-icon {
  width: 35px !important;
  height: 35px !important;
}
.burger_block .basket_version div {
  top: 0px;
  right: 0px;
  background: var(--randy-red-dark);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
.burger_block .basket_version div p {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  font-family: AppFont, sans-serif;
}
@media (max-width: 992px) {
  .burger_block .basket_version {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/variables.scss","webpack://./node_modules/@angular/material/core/tokens/_token-utils.scss","webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAcA;EC8DQ,mCAAA;EAAA,6BAAA;EAAA,gJAAA;EAAA,iJAAA;EAAA,iJAAA;EAAA,iJAAA;EAAA,kJAAA;EAAA,kJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,mJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,qJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,sJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,uJAAA;EAAA,gEAAA;EAAA,kFAAA;EAAA,iFAAA;EAAA,sCAAA;EAAA,qDAAA;EAAA,gDAAA;EAAA,wCAAA;EAAA,qEAAA;EAAA,qGAAA;EAAA,uGAAA;EAAA,4DAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,6GAAA;EAAA,+DAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,sCAAA;EAAA,4CAAA;EAAA,sJAAA;EAAA,0CAAA;EAAA,mJAAA;EAAA,4CAAA;EAAA,qJAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,iDAAA;EAAA,4CAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,8CAAA;EAAA,0CAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,+CAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kDAAA;EAAA,uCAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,4CAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,oDAAA;EAAA,0DAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,kDAAA;EAAA,8CAAA;EAAA,oGAAA;EAAA,0FAAA;EAAA,0FAAA;EAAA,2FAAA;EAAA,oDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,uDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,qGAAA;EAAA,6FAAA;EAAA,+FAAA;EAAA,+FAAA;EAAA,6DAAA;EAAA,kDAAA;EAAA,mEAAA;EAAA,6DAAA;EAAA,mEAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,6DAAA;EAAA,iDAAA;EAAA,kDAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,iGAAA;EAAA,iGAAA;EAAA,8FAAA;EAAA,oDAAA;EAAA,+DAAA;EAAA,4DAAA;EAAA,+DAAA;EAAA,4DAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,mDAAA;EAAA,+DAAA;EAAA,mDAAA;EAAA,gDAAA;EAAA,gGAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,6CAAA;EAAA,uCAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,8DAAA;EAAA,gEAAA;EAAA,wDAAA;EAAA,mDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,6DAAA;EAAA,+CAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,2DAAA;EAAA,6CAAA;EAAA,qDAAA;EAAA,8CAAA;EAAA,sJAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,sFAAA;EAAA,4CAAA;EAAA,yCAAA;EAAA,+EAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,8CAAA;EAAA,kDAAA;EAAA,6CAAA;EAAA,oCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,4JAAA;EAAA,4CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,6CAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,kCAAA;EAAA,0DAAA;EAAA,uCAAA;EAAA,4CAAA;EAAA,sDAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,qDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,6BAAA;EAAA,2CAAA;EAAA,qCAAA;EAAA,gDAAA;EAAA,wCAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,oCAAA;EAAA,kEAAA;EAAA,kFAAA;EAAA,+EAAA;EAAA,qDAAA;EAAA,+FAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,yDAAA;EAAA,oDAAA;EAAA,mDAAA;EAAA,oDAAA;EAAA,mDAAA;EAAA,6CAAA;EAAA,8DAAA;EAAA,gDAAA;EAAA,0DAAA;EAAA,0DAAA;EAAA,qDAAA;EAAA,iDAAA;EAAA,wCAAA;EAAA,iDAAA;EAAA,mEAAA;EAAA,0DAAA;EAAA,iCAAA;EAAA,8CAAA;EAAA,0CAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,iCAAA;EAAA,sDAAA;EAAA,uDAAA;EAAA,+CAAA;EAAA,2DAAA;EAAA,yDAAA;EAAA,+DAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA,4CAAA;EAAA,4DAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,oEAAA;EAAA,4DAAA;EAAA,oDAAA;EAAA,sEAAA;EAAA,yCAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,6DAAA;EAAA,+CAAA;EAAA,6CAAA;EAAA,qEAAA;EAAA,uEAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA,8CAAA;EAAA,0CAAA;EAAA,qDAAA;EAAA,0DAAA;EAAA,wDAAA;EAAA,yDAAA;EAAA,4DAAA;EAAA,0DAAA;EAAA,2DAAA;EAAA,mEAAA;EAAA,4CAAA;EAAA,uDAAA;EAAA,4DAAA;EAAA,2DAAA;EAAA,sDAAA;EAAA,iDAAA;EAAA,uDAAA;EAAA,4DAAA;EAAA,2DAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,yDAAA;EAAA,8DAAA;EAAA,6DAAA;EAAA,wDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,yDAAA;EAAA,8DAAA;EAAA,6DAAA;EAAA,wDAAA;EAAA,mDAAA;EAAA,yDAAA;EAAA,8DAAA;EAAA,6DAAA;EAAA,wDAAA;EAAA,iDAAA;EAAA,2DAAA;EAAA,gEAAA;EAAA,+DAAA;EAAA,0DAAA;EAAA,kDAAA;EAAA,8CAAA;EAAA,sDAAA;EAAA,kDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,kDAAA;EAAA,gDAAA;EAAA,mCAAA;EAAA,yCAAA;EAAA,8EAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,qCAAA;EAAA,iCAAA;EAAA,8CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,uCAAA;EAAA,kCAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,gDAAA;EAAA,yDAAA;EAAA,0DAAA;EAAA,iFAAA;EAAA,qCAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,uCAAA;EAAA,mDAAA;EAAA,2DAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA,qDAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,wCAAA;EAAA,kFAAA;EAAA,kCAAA;EAAA,4IAAA;EAAA,iCAAA;EAAA,wCAAA;EAAA,iFAAA;EAAA,0CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,kCAAA;EAAA,uDAAA;EAAA,4DAAA;EAAA,oDAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,+BAAA;EAAA,iCAAA;EAAA,yCAAA;EAAA,mCAAA;EAAA,oFAAA;EAAA,qFAAA;EAAA,mCAAA;EAAA,oJAAA;EAAA,mDAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,6CAAA;EAAA,sCAAA;EAAA,0CAAA;EAAA,yCAAA;EAAA,iDAAA;EAAA,uCAAA;EAAA,uDAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,0DAAA;EAAA,yDAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA,oDAAA;EAAA,8CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,4DAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,mDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,6DAAA;EAAA,yDAAA;EAAA,mDAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,sEAAA;EAAA,+DAAA;EAAA,4DAAA;EAAA,gEAAA;EAAA,yDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,6CAAA;EAAA,mDAAA;EAAA,iFAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,iDAAA;EAAA,0DAAA;EAAA,2CAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,iDAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,6BAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,sCAAA;EAAA,gCAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,4CAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,gCAAA;EAAA,6CAAA;EAAA,yCAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,uDAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,yDAAA;EAAA,2DAAA;EAAA,sCAAA;EAAA,iFAAA;EAAA,yDAAA;EAAA,yFAAA;EAAA,2FAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,iDAAA;EAAA,wDAAA;EAAA,iDAAA;EAAA,wDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,6CAAA;EAAA,4DAAA;EAAA,0CAAA;EAAA,qCAAA;EAAA,kDAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,8CAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oDAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,0FAAA;EAAA,2FAAA;EAAA,uDAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,6CAAA;EAAA,qDAAA;EAAA,8EAAA;EAAA,8CAAA;EAAA,6FAAA;EAAA,0FAAA;EAAA,yDAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,uDAAA;EAAA,gFAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,gKAAA;EAAA,6FAAA;EAAA,wKAAA;EAAA,8FAAA;EAAA,0DAAA;EAAA,sKAAA;EAAA,sDAAA;EAAA,sKAAA;EAAA,sDAAA;EAAA,gDAAA;EAAA,wKAAA;EAAA,wDAAA;EAAA,iFAAA;EAAA,iDAAA;EAAA,yFAAA;EAAA,qDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mDAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,yFAAA;EAAA,0FAAA;EAAA,sDAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,4CAAA;EAAA,oDAAA;EAAA,6EAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,iDAAA;EAAA,kDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,8CAAA;EAAA,uDAAA;EAAA,6CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,yDAAA;EAAA,+CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0DAAA;EAAA,gDAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,qDAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,sDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,iCAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,mFAAA;EAAA,qDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,4EAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,+BAAA;EAAA,yCAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,iCAAA;EAAA,uCAAA;EAAA,kCAAA;EAAA,qJAAA;EAAA,sFAAA;EAAA,uFAAA;EAAA,8JAAA;EAAA,oKAAA;EAAA,oKAAA;EAAA,wDAAA;EAAA,2JAAA;EAAA,yCAAA;EAAA,mCAAA;EAAA,2JAAA;EAAA,yCAAA;EAAA,6JAAA;EAAA,2CAAA;EAAA,oEAAA;EAAA,wCAAA;EAAA,2JAAA;EAAA,4FAAA;EAAA,6FAAA;EAAA,iKAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,iKAAA;EAAA,+CAAA;EAAA,mKAAA;EAAA,iDAAA;EAAA,0EAAA;EAAA,0CAAA;EAAA,oCAAA;EAAA,qCAAA;EAAA,sDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,yCAAA;EAAA,oCAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,8CAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,uCAAA;EAAA,qCAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,0CAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,wDAAA;EAAA,oDAAA;EAAA,8CAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,2DAAA;EAAA,uDAAA;EAAA,iDAAA;EAAA,qDAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,kDAAA;EAAA,sDAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,oCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,gDAAA;EAAA,sDAAA;EAAA,+CAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,qCAAA;EAAA,yFAAA;EAAA,8CAAA;EAAA,+BAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,uCAAA;EAAA,mCAAA;EAAA,yCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,wCAAA;EAAA,gDAAA;EAAA,sDAAA;EAAA,0DAAA;EAAA,qDAAA;EAAA,4CAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,+BAAA;EAAA,iDAAA;EAAA,0GAAA;EAAA,oGAAA;EAAA,gEAAA;EAAA,2FAAA;EAAA,0CAAA;EAAA,4DAAA;EAAA,sDAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,uDAAA;EAAA,mDAAA;EAAA,6CAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,kKAAA;EAAA,+CAAA;EAAA,wKAAA;EAAA,qDAAA;EAAA,wDAAA;EAAA,6DAAA;EAAA,uDAAA;EAAA,sGAAA;EAAA,yGAAA;EAAA,wGAAA;EAAA,kFAAA;EAAA,wFAAA;EAAA,+EAAA;EAAA,uEAAA;EAAA,yDAAA;EAAA,mEAAA;EAAA,qHAAA;EAAA,uEAAA;EAAA,iEAAA;EAAA,kDAAA;EAAA,+GAAA;EAAA,2DAAA;EAAA,0EAAA;EAAA,2DAAA;EAAA,oDAAA;EAAA,+DAAA;EAAA,2DAAA;EAAA,2DAAA;EAAA,yGAAA;EAAA,oGAAA;EAAA,qDAAA;EAAA,wDAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,2DAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA,6CAAA;EAAA,wBAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,sDAAA;EAAA,qDAAA;EAAA,yJAAA;EAAA,8CAAA;EAAA,mDAAA;EAAA,6CAAA;EAAA,iDAAA;EAAA,8FAAA;EAAA,4FAAA;EAAA,2FAAA;EAAA,+CAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA,kDAAA;EAAA,uDAAA;EAAA,kDAAA;EAAA,yCAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,oDAAA;EAAA,+CAAA;EAAA,sCAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,mFAAA;EAAA,0FAAA;EAAA,mFAAA;EAAA,0FAAA;EAAA,yBAAA;EAAA,mCAAA;EAAA,8CAAA;EAAA,oCAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,uEAAA;EAAA,mEAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,sCAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,8DAAA;EAAA,+DAAA;EAAA,0DAAA;EAAA,0FAAA;EAAA,yFAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,8CAAA;EAAA,uDAAA;EAAA,kEAAA;EAAA,kEAAA;EAAA,6DAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,qDAAA;EAAA,wDAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,0DAAA;EAAA,6DAAA;EAAA,0DAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,iDAAA;EAAA,2CAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,8CAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,6CAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,qCAAA;EAAA,oDAAA;EAAA,0JAAA;ACu1BR;;AFj5BA;EACC,+BAAA;EACA,8BAAA;EACA,iCAAA;EAEA,0BAAA;EACA,yBAAA;EAGA,oBAAA;EACA,yBAAA;EACA,qBAAA;EACA,0BAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EAEA,qCAAA;EACA,0DAAA;EACA,gCAAA;EACA,qCAAA;EACA,wDAAA;EACA,gEAAA;EACA,wCAAA;EAEA,sCAAA;EACA,qCAAA;AE+4BD;;AF54BA;EACC,wCAAA;EACA,4CAAA;EACA,oDAAA;EACA,4DAAA;EACA,8CAAA;EACA,4CAAA;AE+4BD;;AAj8BA;;;EAGC,aAAA;AAo8BD;;AAh8BA;EACC,8BAAA;EACA,kBAAA;AAm8BD;AAj8BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAm8BF;AAh8BC;EACC,WAAA;EACA,YAAA;EACA,eAAA;AAk8BF;AA/7BC;EACC,eAAA;EACA,wBAAA;EACA,eAAA;AAi8BF;;AA57BA;EACC,iBAAA;AA+7BD;;AA57BA;EACC,yCAAA;AA+7BD;;AA57BA;EACC,gCAAA;EACA,8BAAA;AA+7BD;;AA57BA;EACC,cAAA;AA+7BD;;AA37BA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AA87BD;AA57BC;EACC,yBAAA;EACA,WAAA;EACA,YAAA;AA87BF;;AA17BA;EACC,WAAA;AA67BD;;AA17BA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AA67BD;ACpgCE;EDoEF;IAME,aAAA;IACA,4DAAA;IACA,SAAA;EA87BA;AACF;;AA37BA;EACC,sCAAA;EACA,0BAAA;EACA,0BAAA;EACA,+BAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;AA87BD;ACvhCE;EDgFF;IAYE,WAAA;EA+7BA;AACF;;AA17BA;EACC,kBAAA;AA67BD;AA37BC;EACC,iBAAA;AA67BF;;AAz7BA;EACC,mBAAA;AA47BD;;AAz7BA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;AA47BD;;AAz7BA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AA47BD;;AAz7BA;EACC,YAAA;EACA,gBAAA;AA47BD;;AAz7BA;EACC,cAAA;EACA,YAAA;AA47BD;;AAz7BA;EACC,gBAAA;AA47BD;;AAx7BA;EACC,8BAAA;EACA,uBAAA;EACA,yCAAA;AA27BD;;AC1kCE;EDkJF;IAEE,aAAA;EA27BA;AACF;;AAz7BA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA;EACA,oCAAA;EACG,wCAAA;EACH,kBAAA;AA47BD;AA17BC;EACC,aAAA;AA47BF;AAz7BC;EACC,cAAA;AA27BF;;AAx7BA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,qBAAA;AA27BD;;AAx7BA;EACC,UAAA;EACA,aAAA;EACA,qBAAA;AA27BD;;AAx7BA;EACC,YAAA;EACA,gBAAA;AA27BD;;AAz7BA;EACC,YAAA;EACA,8BAAA;EACA,kCAAA;EACA,yBAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA47BD;AA17BC;EACC,eAAA;EACM,gBAAA;EACN,SAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;AA47BF;AAz7BC;EACC,4BAAA;EACA,8BAAA;AA27BF;AAz7BE;EACC,YAAA;AA27BH;AAv7BC;EACC,eAAA;EACA,WAAA;EACA,qBAAA;EACA,kCAAA;AAy7BF;AAt7BE;EACC,eAAA;EACA,wBAAA;EACA,SAAA;AAw7BH;;AAn7BA;EACC,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAs7BD;AAr7BC;EACC,sBAAA;AAu7BF;;AAh7BA;EACC,8BAAA;AAm7BD;;AAh7BA;EACC,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AAm7BD;AAj7BC;EACO,sBAAA;EACN,YAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;AAm7BF;AC3rCE;EDiQD;IASG,YAAA;EAq7BF;AACF;AAj7BC;EACC,OAAA;EACA,oBAAA;EACA,eAAA;EACM,gBAAA;EACN,iBAAA;EACA,YAAA;AAm7BF;AAj7BE;EACC,uBAAA;EACA,0BAAA;EACA,gBAAA;AAm7BH;;AA96BA;EACC,eAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,8BAAA;EACA,0BAAA;EACA,WAAA;AAi7BD;ACxtCE;ED+RF;IAWE,aAAA;EAk7BA;AACF;AAh7BC;EACC,SAAA;AAk7BF;;AA96BA;EACC,eAAA;EACA,YAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,2CAAA;AAi7BD;AC/uCE;EDkTF;IAeE,aAAA;EAk7BA;AACF;AAh7BC;EACC,SAAA;AAk7BF;;AA96BA;EACC,cAAA;EACA,YAAA;EACA,8BAAA;AAi7BD;;AA76BA;EACE,aAAA;EACA,mBAAA;AAg7BF;AA/6BE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAi7BJ;AAh7BI;EACE,sBAAA;EACA,uBAAA;AAk7BN;AAh7BI;EACE,QAAA;EACA,UAAA;EACA,iCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAk7BN;AAj7BM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gCAAA;AAm7BR;AC7xCE;EDmVA;IA4BI,aAAA;EAk7BJ;AACF","sourcesContent":["@use '@angular/material' as mat;\n\n@include mat.core();\n\n$theme: mat.define-theme(\n\t(\n\t\tcolor: (\n\t\t\ttheme-type: light,\n\t\t\tprimary: mat.$orange-palette,\n\t\t\ttertiary: mat.$rose-palette,\n\t\t)\n\t)\n);\n\nhtml {\n\t@include mat.all-component-themes($theme);\n}\n\n:root {\n\t--ion-color-gray-light: #f5f5f5;\n\t--ion-color-gray-dark: #d4d4d4;\n\t--ion-color-gray-darkest: #1f1b1c;\n\n\t--ion-color-black: #012734;\n\t--ion-color-gold: #a38a5f;\n\n\t// Randy's Pizza Brand Colors\n\t--randy-red: #DD2E4E;\n\t--randy-red-dark: #DD2E4E;\n\t--randy-gray: #41403B;\n\t--randy-gray-dark: #2d2d2d;\n\t--randy-beige: #FFF5E0;\n\t--randy-beige-dark: #EAE5DD;\n\t--randy-border: #CCCCCC;\n\n\t--quantity-selector-border-width: 2px;\n\t--quantity-selector-border-color: var(--ion-color-primary);\n\t--quantity-selector-height: 40px;\n\t--quantity-selector-background: white;\n\t--quantity-selector-text-color: var(--ion-color-primary);\n\t--home-preorder-type-button-background: var(--ion-color-primary);\n\t--preorder-type-chip-border-color: white;\n\n\t--payment-modal-item-background: white;\n\t--payment-modal-checkbox-color: black;\n}\n\n.ion-color-black {\n\t--ion-color-base: var(--ion-color-black);\n\t--ion-color-base-rgb: var(--ion-color-black);\n\t--ion-color-contrast: var(--ion-color-main-contrast);\n\t--ion-color-contrast-rgb: var(--ion-color-main-contrast-rgb);\n\t--ion-color-shade: var(--ion-color-main-shade);\n\t--ion-color-tint: var(--ion-color-main-tint);\n}\n","@use '../style/sass-utils';\n@use 'sass:list';\n@use 'sass:map';\n@use 'sass:string';\n\n// Creates a CSS variable, including the fallback if provided.\n@function _create-var($name, $fallback: null) {\n  @if ($fallback) {\n    @return var($name, $fallback);\n  } @else {\n    @return var($name);\n  }\n}\n\n// Returns a list of overrides for the given M3 get-tokens mixin and prefix. Each token has its\n// prefix removed since the overrides API expects its absence. The returned map includes \"all\" for\n// all override tokens, and also the subsets with keys base, color, typography, and density.\n@function get-overrides($tokens, $prefix) {\n  $base: remove-token-prefixes(map.get($tokens, base), $prefix);\n  $color: remove-token-prefixes(map.get($tokens, color), $prefix);\n  $typography: remove-token-prefixes(map.get($tokens, typography), $prefix);\n  $density: remove-token-prefixes(map.get($tokens, density), $prefix);\n  $all: ();\n  @each $map in ($base, $color, $typography, $density) {\n    $all: map.merge($all, $map);\n  }\n\n  @return (\n    all: $all,\n    base: $base,\n    color: $color,\n    typography: $typography,\n    density: $density,\n  );\n}\n\n// Removes a prefix from each component token in the provided map of prefixed tokens.\n@function remove-token-prefixes($prefixed-tokens: (), $prefix) {\n  $tokens: ();\n  @each $prefixed-token, $value in $prefixed-tokens {\n    $token: string.slice($prefixed-token, string.length($prefix) + 2);\n    $tokens: map.set($tokens, $token, $value);\n  }\n  @return $tokens;\n}\n\n// Returns the token slot value.\n// Accepts an optional fallback parameter to include in the CSS variable.\n// If $fallback is `true`, then use the tokens map to get the fallback.\n@function slot($token, $fallbacks, $fallback: null) {\n  // Fallbacks are a map of base, color, typography, and density tokens. To simplify\n  // lookup, flatten these token groups into a single map.\n  $fallbacks-flattened: ();\n  @each $tokens in map.values($fallbacks) {\n    @each $token, $value in $tokens {\n      $fallbacks-flattened: map.set($fallbacks-flattened, $token, $value);\n    }\n  }\n  @if not map.has-key($fallbacks-flattened, $token) {\n    @error 'Token #{$token} does not exist. Configured tokens are:' +\n        #{map.keys($fallbacks-flattened)};\n  }\n\n  $sys-fallback: map.get($fallbacks-flattened, $token);\n  @if (sass-utils.is-css-var-name($sys-fallback)) {\n    $sys-fallback: _create-var($sys-fallback, $fallback);\n  }\n\n  @return _create-var(--mat-#{$token}, $sys-fallback);\n}\n\n// Outputs a map of token values as CSS variable definitions.\n@mixin values($tokens) {\n  @include sass-utils.current-selector-or-root() {\n    @each $key, $value in $tokens {\n      @if $value != null {\n        --mat-#{$key}: #{$value};\n      }\n    }\n  }\n}\n\n/// Emits new token values for the given token overrides.\n/// Verifies that the overrides passed in are valid tokens.\n/// New token values are emitted under the current selector or root.\n@mixin batch-create-token-values($overrides: (), $namespace-configs) {\n  @include sass-utils.current-selector-or-root() {\n    $prefixed-name-data: ();\n    $all-names: ();\n\n    @each $config in $namespace-configs {\n      $namespace: map.get($config, namespace);\n      $prefix: if(map.has-key($config, prefix), map.get($config, prefix), '');\n      $tokens: map.get(map.get($config, tokens), all);\n      @each $name, $value in $tokens {\n        $prefixed-name: $prefix + $name;\n        $all-names: list.append($all-names, $prefixed-name, $separator: comma);\n        $prefixed-name-data: map.set($prefixed-name-data, $prefixed-name, ($namespace, $name));\n      }\n    }\n\n    @each $name, $value in $overrides {\n      @if map.has-key($prefixed-name-data, $name) {\n        $data: map.get($prefixed-name-data, $name);\n        $namespace: list.nth($data, 1);\n        $name: list.nth($data, 2);\n        $prefixed-name: $namespace + '-' + $name;\n        @include values(($prefixed-name: $value));\n      } @else {\n        @error #{'Invalid token name `'}#{$name}#{'`. '}#{'Valid tokens are: '}#{$all-names};\n      }\n    }\n  }\n}\n","@use \"../../../theme/mixins\" as *;\n@use \"../../../theme/variables\" as var;\n\np,\nh1,\nh2 {\n\tmargin: unset;\n}\n\n// Top Toolbar with Logo and Hamburger Menu\n.top-toolbar {\n\tbackground: var(--randy-beige);\n\tpadding: 16px 20px;\n\t\n\t.toolbar-content {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\t\n\t.brand-logo {\n\t\twidth: 80px;\n\t\theight: auto;\n\t\tcursor: pointer;\n\t}\n\t\n\t.menu-icon {\n\t\tfont-size: 32px;\n\t\tcolor: var(--randy-gray);\n\t\tcursor: pointer;\n\t}\n}\n\n// Category Tabs Block\n.category-tabs-block {\n\tbackground: white;\n}\n\nion-content {\n\tbackground: var(--randy-beige) !important;\n}\n\n.articles-content {\n\t--background: var(--randy-beige);\n\tbackground: var(--randy-beige);\n}\n\n.main {\n\toverflow: auto;\n}\n\n// Loading and empty states\n.center {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-height: 300px;\n\t\n\tion-spinner {\n\t\t--color: var(--randy-red);\n\t\twidth: 48px;\n\t\theight: 48px;\n\t}\n}\n\n.item-card {\n\twidth: 100%;\n}\n\n.articles-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\t\n\t@include desktop {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n\t\tgap: 24px;\n\t}\n}\n\nion-searchbar {\n\t--placeholder-color: var(--randy-gray);\n\t--placeholder-opacity: 0.6;\n\t--color: var(--randy-gray);\n\t--icon-color: var(--randy-gray);\n\t--border-radius: 8px;\n\t--background: white;\n\t--box-shadow: none;\n\tborder: 2px solid var(--randy-border);\n\tborder-radius: 8px;\n\t\n\t@include desktop {\n\t\twidth: auto;\n\t}\n}\n\n// Removed unused styles\n\n.items-wrap {\n\tpadding: 32px 20px;\n\t\n\t&:first-of-type {\n\t\tpadding-top: 24px;\n\t}\n}\n\n.category-header-wrap {\n\tmargin-bottom: 24px;\n}\n\n.category-title {\n\tfont-family: AppFontBold;\n\tfont-size: 32px;\n\tline-height: 40px;\n\tcolor: var(--randy-gray);\n\tmargin-bottom: 8px;\n}\n\n.category-subtitle {\n\tfont-family: AppFontBold;\n\tfont-size: 12px;\n\tline-height: 22px;\n\tcolor: var(--randy-red);\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n}\n\n.order-col {\n\tmin-width: 380px;\n}\n// Removed old category-header styles\n// Removed old category styles - now using category-header-wrap\nion-footer {\n\tbackground: var(--randy-beige);\n\tpadding: 16px 20px 24px;\n\tbox-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.footer-btn {\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n.category-list {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\ttransition: 0.3s ease;\n\topacity: 1;\n\toverflow-x: auto;\n\toverflow-y: hidden;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none;\n\tbackground-color: var(--randy-beige);\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n\tpadding: 16px 20px;\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t.category {\n\t\tflex: 0 0 auto;\n\t}\n}\n.search-block {\n\tpadding: 16px 20px;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground: white;\n\topacity: 1;\n\ttransition: 0.3s ease;\n}\n\n.hidden {\n\topacity: 0;\n\tdisplay: none;\n\ttransition: 0.3s ease;\n}\n\n.main-row {\n\theight: 100%;\n\toverflow: hidden;\n}\nion-chip {\n\theight: 44px;\n\tbackground: var(--randy-beige);\n\tborder: 2px solid var(--randy-red);\n\ttransition: all 0.2s ease;\n\tmin-width: 44px;\n\tpadding: 0 20px !important;\n\tborder-radius: 8px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\tion-label {\n\t\tfont-size: 14px;\n        font-weight: 500;\n\t\tmargin: 0;\n\t\tcolor: var(--randy-gray);\n\t\tfont-family: AppFont;\n\t\twhite-space: nowrap;\n\t}\n\n\t&.selected {\n\t\tbackground: var(--randy-red);\n\t\tborder-color: var(--randy-red);\n\t\t\n\t\tion-label {\n\t\t\tcolor: white;\n\t\t}\n\t}\n\n\t&.chip-icon {\n\t\tmin-width: 44px;\n\t\twidth: 44px;\n\t\tpadding: 0 !important;\n\t\tborder: 2px solid var(--randy-red);\n\t\t// background: white;\n\t\t\n\t\t.icon {\n\t\t\tfont-size: 20px;\n\t\t\tcolor: var(--randy-gray);\n\t\t\tmargin: 0;\n\t\t}\n\t}\n}\n\n.service-not-available-container {\n\t--padding-start: 20px !important;\n\t--padding-end: 10px;\n\t--padding-top: 10px;\n\t--padding-bottom: 10px;\n\tion-icon {\n\t\tcolor: #fff !important;\n\t}\n}\n\n// Removed old banner-row - allergen banner now in header\n\n// Allergen Banner\n.allergen-banner-col {\n\tbackground: var(--randy-beige);\n}\n\n.allergen-banner {\n\tbackground: #41403B80;\n\tpadding: 12px 20px;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tgap: 12px;\n\tpadding-left: 30px;\n\n\t.info-icon {\n        width: 27px !important;\n\t\tcolor: white;\n\t\tfont-size: 24px;\n\t\tflex-shrink: 0;\n\t\tright: auto;\n\t\tleft: 0;\n\t\tbottom: 9px;\n\t\t\t@include mobile {\n\t\t\t\tbottom: 16px;\n\t\t}\n\t}\n\n\n\t.info {\n\t\tflex: 1;\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n        font-weight: 400;\n\t\tline-height: 16px;\n\t\tcolor: white;\n\t\t\n\t\ta.link-red {\n\t\t\tcolor: var(--randy-red);\n\t\t\ttext-decoration: underline;\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n}\n\n.expand-block {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100vw;\n\tright: -100%;\n\ttop: 0;\n\tbackground: rgba(0, 0, 0, 0.3);\n\tbackdrop-filter: blur(2px);\n\tz-index: 10;\n\t\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t\n\t&.show {\n\t\tright: 0%;\n\t}\n}\n\n.sidebar {\n\tposition: fixed;\n\tright: -100%;\n\ttop: 0;\n\twidth: 420px;\n\tmax-width: 90vw;\n\theight: 100vh;\n\tbackground: white;\n\tz-index: 11;\n\tdisplay: flex;\n\tflex-direction: column;\n\ttransition: right 0.3s ease-in-out;\n\tbox-shadow: -4px 0 16px rgba(0, 0, 0, 0.15);\n\t\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\t\n\t&.show {\n\t\tright: 0%;\n\t}\n}\n\napp-order-content {\n\tdisplay: block;\n\theight: 100%;\n\tbackground: var(--randy-beige);\n}\n\n\n.burger_block {\n  display: flex;\n  align-items: center;\n  .basket_version {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    ion-icon {\n      width: 35px !important;\n      height: 35px !important;\n    }\n    div {\n      top: 0px;\n      right: 0px;\n      background: var(--randy-red-dark);\n      border-radius: 50%;\n      width: 15px;\n      height: 15px;\n      position: absolute;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      p {\n        font-size: 14px;\n        font-weight: 700;\n        color: #fff;\n        font-family: AppFont, sans-serif;\n      }\n    }\n\n    @include mobile {\n      display: none;\n    }\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
